
// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React, {Component} from 'react'

import {Field, reduxForm} from 'redux-form'
import {FormGroup, InputField, DropDownListField} from '../../form'

import {fetchLogs} from '../../../actions/auditViewer'

import {validateTimeInterval} from '../TimeInterval/'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'

import './index.css'

export const SEVERITY_FATAL = 'Fatal'
export const SEVERITY_WARNING = 'Warning'
export const SEVERITY_INFO = 'Info'
export const SEVERITY_DEBUG = 'Debug'
export const SEVERITY_TRACE = 'Trace'
export const SEVERITY_ALL = 'All'

export const STATUS_ALL = 'All'
export const STATUS_PASS = 'Pass'
export const STATUS_FAIL = 'Fail'

class FilterDetails extends Component {
  componentDidMount () {
    const {handleSubmit} = this.props
    window.setTimeout(handleSubmit, 0)
  }
  render () {
    const {handleSubmit, invalid} = this.props

    return (
      <div className='filter-details'>
        <form className=' form filter-details-form inline-form round-border-fields row' onSubmit={handleSubmit}>
          <div className='row col-12 with-background'>
            <div className='col-md-6 col-xl-5'>
              <div className='row'>
                <div className='form-item'>
                  <span>Status &nbsp;</span>
                  <div className='hidden-fields'>
                    <Field
                      name='startDate'
                      type='hidden'
                      component={InputField}
                      className='col-6 col-xl-3'
                    />
                    <Field
                      name='endDate'
                      type='hidden'
                      component={InputField}
                      className='col-6 col-xl-3'
                    />
                    <Field
                      name='startTime'
                      type='hidden'
                      component={InputField}
                      className='col-6 col-xl-3'
                    />
                    <Field
                      name='endTime'
                      type='hidden'
                      component={InputField}
                      className='col-6 col-xl-3'
                    />
                  </div>
                  <FormGroup >
                    <Field
                      name='severity'
                      data={[STATUS_ALL, STATUS_PASS, STATUS_FAIL]}
                      component={DropDownListField}
                    />
                  </FormGroup>
                </div>
              </div>
            </div>
            <div className='col-md-6 col-xl-7'>
              <div className='row'>
                <div className='col'>
                  <div className='form-item'>
                    <span>and/or Type &nbsp;</span>
                    <FormGroup >
                      <Field
                        name='severity'
                        data={[SEVERITY_ALL, SEVERITY_FATAL, SEVERITY_WARNING, SEVERITY_INFO, SEVERITY_DEBUG, SEVERITY_TRACE]}
                        component={DropDownListField}
                      />
                    </FormGroup>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='col-md-12 buttons'>
            <div className='col-md-3 pull-right'>
              <button className='btn-go btn-with-icon pull-right' type='submit' disabled={invalid}>
                <span>Go</span>
                <div className='icon'>
                  <ArrowForwardIosIcon />
                </div>
              </button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

function validate (values) {
  let ret = validateTimeInterval(values)
  return ret
}

function onSubmit (values, dispatch) {
  dispatch(fetchLogs(values))
}

export default reduxForm({
  form: 'FilterDetails',
  onSubmit: onSubmit,
  validate: validate
})(FilterDetails)
